import React from "react";
import Main from "../../components/workshop-network/Main";
import Layout from "layouts/Layout";
import { Container } from "react-bootstrap";
import Head from 'next/head';

const NewWorkshop = () => {
  return (
    <Layout
      navPositionClass="justify-content-center"
      carData={true}
      title={"OB Workshop Network"}
      locationOn={false}
      hideFooter={true}
    >
      <Head>
        <meta
          name="description"
          content="We Have The Widest Network Of Verified & Trusted Car Service Providers Who Work Under Our Guidelines to Provide Quality Services At Affordable Cost."
        />
      </Head>
      <Container
        className="margin-nav"
        id="top"
        style={{ background: "none" }}
      ></Container>
      <Main />
    </Layout>
  );
};

export default NewWorkshop;
